export default "__VITE_ASSET__e9d7a7b5__"